import { Component, Input } from '@angular/core';
import { EntryFeeCalculationWithAllRatiosOut } from 'src/app/services/rest-api/rest-api';
import { ExitFeeYearRatios, FeeInfoItemTypes } from './entry-fee-info-item/entry-fee-info-item';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'libero-entry-fee-calc',
  templateUrl: './entry-fee-calc.component.html',
  styleUrls: ['./entry-fee-calc.component.scss'],
  standalone: false
})
export class EntryFeeCalcComponent {
    @Input() public entryFeeToDisplay: EntryFeeCalculationWithAllRatiosOut | null = null;
    @Input() public currencyCode = 'CZK'
    @Input() public loading = false;
    @Input() public useStrategyStyling = false;

    public feeInfoItemTypes = FeeInfoItemTypes;

    public get exitFeeInTime(): ExitFeeYearRatios | null {
      if(!this.entryFeeToDisplay) {
        return null;
      }
      return {
        exitFeeRatioYear1: this.entryFeeToDisplay.exitFeeRatioYear1,
        exitFeeRatioYear2: this.entryFeeToDisplay.exitFeeRatioYear2,
        exitFeeRatioYear3: this.entryFeeToDisplay.exitFeeRatioYear3,
        exitFeeRatioYear4: this.entryFeeToDisplay.exitFeeRatioYear4,
        exitFeeRatioYear5: this.entryFeeToDisplay.exitFeeRatioYear5,
      }
    }

    public constructor(
      public userService: UserService,
    ) {}
}
